// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Mweb","messages":"Chat_messages__1rRhk","dateDivider":"Chat_dateDivider__2GZhn"};